import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizedData } from 'osn-shared';

@Pipe({ name: 'currentLocale', pure: false })
export class CurrentLocalePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  public transform<T>(value: LocalizedData<T>): T;
  public transform<T, K extends keyof LocalizedData<T>>(value: LocalizedData<T>, locale: K): T;
  public transform<T, K extends keyof LocalizedData<T>>(value: LocalizedData<T>, locale?: K): T {
    return value[locale ?? this.translateService.currentLang];
  }
}
